import {
  GET_USERDASHBOARD,
  GET_USERDASHBOARD_SUCCESS,
  GET_USERDASHBOARD_FAIL,
  GET_REPORTDASHBOARD,
  GET_REPORTDASHBOARD_SUCCESS,
  GET_REPORTDASHBOARD_FAIL,
} from "./actionTypes"

export const getuserDashboard = () => ({
  type: GET_USERDASHBOARD,
})

export const getuserDashboardSuccess = userDashboard => ({
  type: GET_USERDASHBOARD_SUCCESS,
  payload: userDashboard,
})

export const getuserDashboardFail = error => ({
  type: GET_USERDASHBOARD_FAIL,
  payload: error,
})

export const getReportDashboard = () => ({
 
  type: GET_REPORTDASHBOARD,
})

export const getReportDashboardSuccess = reportDashboard => ({
  type: GET_REPORTDASHBOARD_SUCCESS,
  payload: reportDashboard,
})

export const getReportDashboardFail = error => ({
  type: GET_REPORTDASHBOARD_FAIL,
  payload: error,
})
